module.exports = __webpack_public_path__ + "assets/img/16_1810_big.0fef6f88.jpg";